import React, { PureComponent } from 'react';

export class OYDistances extends PureComponent {
  render() {
    return (
      <div />
    );
  }
}
